/**
 * Product name for the campaign knowledge assistant. The capitals are the
 * point — "GuIA" carries IA inside the word for guide.
 */
export const ASSISTANT_PRODUCT_NAME = "GuIA";

export const ASSISTANT_PRODUCT_TAGLINE =
  "Conocimiento de campaña";
